import { store } from '@/index'
import { addDebugLog } from '@/store/slices/debugSlice'

class DebugLogger {
  private dispatch: any

  constructor() {
    // Store will be set after initialization
    this.dispatch = null
  }

  setStore(appStore: any) {
    this.dispatch = appStore.dispatch
  }

  log(message: string, data?: any, source?: string) {
    console.log(message, data)
    if (this.dispatch) {
      this.dispatch(addDebugLog({
        level: 'log',
        message,
        data,
        source
      }))
    }
  }

  info(message: string, data?: any, source?: string) {
    console.info(message, data)
    if (this.dispatch) {
      this.dispatch(addDebugLog({
        level: 'info',
        message,
        data,
        source
      }))
    }
  }

  warn(message: string, data?: any, source?: string) {
    console.warn(message, data)
    if (this.dispatch) {
      this.dispatch(addDebugLog({
        level: 'warn',
        message,
        data,
        source
      }))
    }
  }

  error(message: string, data?: any, source?: string) {
    console.error(message, data)
    if (this.dispatch) {
      this.dispatch(addDebugLog({
        level: 'error',
        message,
        data,
        source
      }))
    }
  }
}

// Create singleton instance
const debugLogger = new DebugLogger()

export default debugLogger